import { siteSearchTypeaheadValueSchema } from 'components/Core/CoreSiteSearch/utils';

type SiteSearchSelection =
  | {
      type: 'query';
      query: string;
    }
  | {
      type: 'link';
      href: string;
    };

export const resolveSiteSearchSelection = (itemValue: string): SiteSearchSelection | null => {
  const parsedValue = (() => {
    try {
      return JSON.parse(itemValue) as unknown;
    } catch {
      return itemValue;
    }
  })();

  const typeaheadValue = siteSearchTypeaheadValueSchema.safeParse(parsedValue);

  if (typeaheadValue.success) {
    const { href, title, type } = typeaheadValue.data;

    if (type === 'query') {
      return { type: 'query', query: title };
    }

    return { type: 'link', href };
  }

  const selectedUrl = (() => {
    try {
      return new URL(itemValue, 'https://example.com');
    } catch {
      return null;
    }
  })();

  if (!selectedUrl || selectedUrl.pathname !== '/search') {
    return null;
  }

  const query = selectedUrl.searchParams.get('query')?.trim();

  if (!query) {
    return null;
  }

  return { type: 'query', query };
};
